module.exports = __webpack_public_path__ + "img/tarjeta.98c628c6.png";